module.exports = __webpack_public_path__ + "static/media/Kurt Spitzer Headshot.c83a5108.jpeg";